import * as React from 'react';
import { Modal as ModalStandard } from '@emorg-prd/standard-react';
import { Alert } from '../../common';
import './AlertModal.css';
import { AlertBanner } from '../../../models/interfaces/AlertBanner';

interface ModalProps extends AlertBanner {
    willTimeout: boolean;
    onClose: (event: React.ChangeEvent<any>) => void;
}
interface ModalState {
}

export default class WarningModal extends React.Component<ModalProps, ModalState> {
    handleOnCloseAlert = () => {
        setTimeout(this.props.onClose, 1);
    };
    
    componentDidMount() {
        const overlay = document.querySelector('.alert-modal .em-c-modal__overlay');
        if (overlay) {
            const handler = (e: Event) => {
              e.stopPropagation(); // blocks closing by overlay
            };
            overlay.addEventListener('click', handler, true);
            // refs for cleanup
            (this as any)._overlay = overlay;
            (this as any)._overlayHandler = handler;
        }
    }

    componentDidUpdate = () => {
        if (this.props.visible && this.props.willTimeout) {
            setTimeout(this.props.onClose, 4000);
        }
    };
        
    componentWillUnmount() {
        const overlay = (this as any)._overlay as HTMLElement | undefined;
        const handler = (this as any)._overlayHandler as ((e: Event) => void) | undefined;
        overlay?.removeEventListener('click', handler!, true);
    }

    render() {
        return (
            <ModalStandard
                show={this.props.visible}
                optionalClass='alert-modal'
            >
                <Alert 
                    className='alert' 
                    onClose={this.handleOnCloseAlert} 
                    variant={this.props.variant}
                    body= {this.props.text}
                />
            </ModalStandard>
        );
    }
}
